export const trackingId = process.env.NEXT_PUBLIC_REACT_APP_GA;

export const pageview = (url) => {
  window.gtag("config", trackingId, {page_path: url});
};

export const event = ({ action, params }) => {
  window.gtag("event", action, params);
};
